<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Gabinety</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja gabinetu</template>
          <template v-else>Dodawanie gabinetu</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/gabinety')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>
    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab title="Dane ogólne" active>
            <h4 class="mb-3 pb-3 border-bottom">
              Dane ogólne gabinetu
            </h4>
            <validation-observer ref="office-form" tag="form">
              <div class="form-group">
                <label for="name">
                  Nazwa:
                </label>
                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group">
                <validation-provider
                  :rules="'required'"
                  :name="'institution_id'"
                  v-slot="{ errors }">
                  <div class="form-group">
                    <label class="title-box" :for="data.institution_id">
                      Placówka:
                    </label>
                    <v-select
                      class="reservation-style reservation-style-select-max"
                      placeholder="Wybierz placówkę"
                      :options="institutions"
                      v-model="data.institution_id"
                      :reduce="institution => institution.id"
                      label="id">
                      <template #search="{attributes, events}">
                        <d-input
                          class="input-for-select"
                          :state="errors.length ? 'invalid' : null"
                          :required="!data.institution_id"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.name }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.name }}
                        </div>
                      </template>
                    </v-select>
                  </div>
                  <div class="invalid-feedback" style="display: block; margin-top: -0.8rem;">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
          <d-tab title="Lista specjalistów" v-if="isEdit">
            <d-row no-gutters class="page-header py-4 mb-2">
              <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
                <h4>Lista specjalistów dla: <p class="mt-1 mb-0" style="font-weight: 100; color: #17c671">{{data.name}}</p></h4>
              </d-col>
            </d-row>
            <table class="table mt-0 mb-0 full-width">
              <thead class="bg-light">
              <tr>
                <th scope="col" class="border-0">Imię i nazwisko</th>
                <th scope="col" class="border-0">Adres e-mail</th>
                <th scope="col" class="border-0">Harmonogram</th>
              </tr>
              </thead>
              <tbody v-if="loaded">
              <tr
                v-for="(user, index) of officeUsers[0]"
                :key="'office-users-' + index">
                <td class="align-middle">
                  {{user ? user.name : ''}} {{user ? user.last_name : ''}}
                </td>
                <td class="align-middle">
                  {{user ? user.email  : ''}}
                </td>
                <td
                  class="align-middle">
                  <d-button
                    theme="info"
                    style="width: 50%;"
                    class="mr-2"
                    :disabled="downloading === user.id"
                    @click.prevent="getSingleUser(user.id)">
                    <template v-if="downloading !== user.id">
                      <i class="material-icons" style="font-size: 1.2rem">person_search</i>
                    </template>
                    <template v-else>
                      <div class="spinner-border spinner-border-sm" role="status"></div>
                    </template>
                  </d-button>
                </td>
              </tr>
              <tr>
                <td v-if="officeUsers[0] ? (!officeUsers[0].length) : true"
                    colspan="5"
                    class="text-center">
                  Brak lekarzy do wyświetlenia&hellip;
                </td>
              </tr>
              </tbody>
            </table>
            <div v-if="!officeUsers" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
    <d-modal
      class="visits__popup"
      v-if="modalUser"
      @close="closeModalUser"
      style="background-color: rgba(0,0,0,0.6)!important;">
      <d-modal-header>
        <d-modal-title class="office__popup_header">
          Harmonogram prac: <span>{{singleUser.name + ' ' + singleUser.last_name}}</span>
        </d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <div class="visits__popup_content">
          <div v-for="(officeId, indexOffice) in singleUser.offices_work_hours" :key="indexOffice">
            <span v-for="(work_hours, indexHours) in  officeId" :key="indexHours">
                <d-card v-for="(office, indexOffice) in  offices" :key="indexOffice" v-if="office.id.toString() === indexHours">
                      <d-card-header class="px-3 py-2" role="tab">
                        <d-btn block-level theme="success" href="#" class="office-button-table-head" v-d-toggle="'accordion-'+ indexOffice"><i class="material-icons">watch_later</i> {{office.name}}</d-btn>
                      </d-card-header>
                      <d-collapse :id="'accordion-'+ indexOffice" accordion="my-accordion">
                        <d-card-body>
                         <div class="form-group office-table">
                           Poniedziałek:
                           <div class="office-table-days">
                             <span class="office-table-days-time" v-if="work_hours.is_open_1 !== '0'">
                                {{ (work_hours.start_time_1 ? work_hours.start_time_1 : 'Brak informacji') + ' - ' + ( work_hours.end_time_1 ? work_hours.end_time_1  : '' ) }}
                             </span>
                             <span class="office-table-days-closed" v-else>
                               Nieczynne
                             </span>
                           </div>
                         </div>
                          <div class="form-group office-table">
                           Wtorek:
                           <div class="office-table-days">
                             <span class="office-table-days-time" v-if="work_hours.is_open_2 !== '0'">
                                {{ (work_hours.start_time_2 ? work_hours.start_time_2 : 'Brak informacji') + ' - ' + ( work_hours.end_time_2 ? work_hours.end_time_2  : '' ) }}
                             </span>
                             <span class="office-table-days-closed" v-else>
                               Nieczynne
                             </span>
                           </div>
                         </div>
                          <div class="form-group office-table">
                           Środa:
                           <div class="office-table-days">
                             <span class="office-table-days-time" v-if="work_hours.is_open_3 !== '0'">
                                {{ (work_hours.start_time_3 ? work_hours.start_time_3 : 'Brak informacji') + ' - ' + ( work_hours.end_time_3 ? work_hours.end_time_3  : '' ) }}
                             </span>
                             <span class="office-table-days-closed" v-else>
                               Nieczynne
                             </span>
                           </div>
                         </div>
                          <div class="form-group office-table">
                           Czwartek:
                            <div class="office-table-days">
                             <span class="office-table-days-time" v-if="work_hours.is_open_4 !== '0'">
                                {{ (work_hours.start_time_4 ? work_hours.start_time_4 : 'Brak informacji') + ' - ' + ( work_hours.end_time_4 ? work_hours.end_time_4  : '' ) }}
                             </span>
                             <span class="office-table-days-closed" v-else>
                               Nieczynne
                             </span>
                           </div>
                         </div>
                          <div class="form-group office-table">
                           Piątek:
                            <div class="office-table-days">
                             <span class="office-table-days-time" v-if="work_hours.is_open_5 !== '0'">
                                {{ (work_hours.start_time_5 ? work_hours.start_time_5 : 'Brak informacji') + ' - ' + ( work_hours.end_time_5 ? work_hours.end_time_5  : '' ) }}
                             </span>
                             <span class="office-table-days-closed" v-else>
                               Nieczynne
                             </span>
                           </div>
                         </div>
                          <div class="form-group office-table">
                           Sobota:
                            <div class="office-table-days">
                             <span class="office-table-days-time" v-if="work_hours.is_open_6 !== '0'">
                                {{ (work_hours.start_time_6 ? work_hours.start_time_6 : 'Brak informacji') + ' - ' + ( work_hours.end_time_6 ? work_hours.end_time_6  : '-' ) }}
                             </span>
                             <span class="office-table-days-closed" v-else>
                               Nieczynne
                             </span>
                           </div>
                         </div>
                          <div class="form-group office-table">
                           Niedziela:
                            <div class="office-table-days">
                             <span class="office-table-days-time" v-if="work_hours.is_open_7 !== '0'">
                                {{ (work_hours.start_time_7 ? work_hours.start_time_7 : '-') + ' - ' + ( work_hours.end_time_7 ? work_hours.end_time_7  : '-' ) }}
                             </span>
                             <span class="office-table-days-closed" v-else>
                               Nieczynne
                             </span>
                           </div>
                         </div>
                        </d-card-body>
                      </d-collapse>
                </d-card>
            </span>
          </div>
        </div>
        <div class="popup-box-buttons">
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="closeModalUser">
            Zamknij
          </d-button>
        </div>
      </d-modal-body>
    </d-modal>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'office-form',
  computed: {
    allDataLoaded () {
      return this.loaded && this.loadedInstitutions;
    },
    isEdit () {
      return !!this.$route.params.id;
    }
  },
  data() {
    return {
      data: {
        name: '',
        id: '',
        institution_id: '',
        users: []
      },
      loaded: false,
      loadError: false,
      institutions: [],
      officesData: [],
      office: [],
      officeUsers: [],
      singleUser: [],
      offices: [],
      loadedInstitutions: false,
      modalUser: false,
      downloading: ''
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }

    this.loadAdditionalData();
    this.getOfficesList();
  },
  watch: {},
  methods: {
    getOfficesList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/offices/items',
        outputKey: 'officesData',
        params: {
          pagination: false
        },
        successAction: () => {
          this.getNewOffice();
        }
      });
    },
    closeModalUser() {
      this.modalUser = false;
    },
    getSingleUser (id) {
      this.downloading = id;
      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/item/' + id,
        outputKey: 'singleUser',
        params: {
          pagination: false
        },
      });
      FormUtils.loadAdditionalData(this, {
        endpoint: '/offices/items',
        outputKey: 'offices',
        params: {
          pagination: false
        },
        successAction: () => {
          setTimeout(() => {
            this.modalUser = true;
            this.downloading = '';
          }, 500)
        }
      });
    },
    getNewOffice () {
      const offices = this.officesData;
      const checkId = this.data.id;
      let arr = [];
      for (let i = 0; i < offices.length; i++) {
        if (checkId === offices[i].id) {
          arr[i] = offices[i].users;
        }
      }
      this.officeUsers = arr.filter(n => n);
    },
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/offices/item/',
        instanceFields: ['name', 'institution_id', 'users', 'id'],
        loadedKey: 'loaded'
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/institutions/items',
        params: {
          pagination: false
        },
        outputKey: 'institutions',
        loadedKey: 'loadedInstitutions',
        errorKey: 'loadError',
        successAction: () => {
          if (this.data.id) {
            this.institutions = this.institutions.filter(institutions => institutions.id !== this.data.institution_id);
          }
        }
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['office-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/offices/update/' + this.id : '/offices/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano gabinet',
        successText: 'Wybrany gabinet został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje gabinetu nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/gabinety')
        }
      });
    },
    prepareFormDataToSend () {
      return {
        name: this.data.name,
        institution_id: this.data.institution_id,
      };
    },
    filterByUsers (option, label, search) {
      return (option.name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    }
  }
};
</script>
<style lang="scss">
  .office__popup_header {
    font-size: 2rem;
    text-align: center;
    span {
      display: block;
      color: #17c671;
      font-weight: 200;
    }
  }
  .office-button-table-head {
    font-size: 1rem;
    i {
      margin-right: 1.5rem;
      padding: 0 0.5rem;
    }
  }
  .office-table {
    display: flex;
    border-bottom: 1px solid #e6e6e6;
    padding: 1rem 0;
    margin-bottom: 0;
    .office-table-days {
      margin-left: 1rem;
      .office-table-days-time {
        color: #17c671;
        font-size: 1.2rem;
        display: block;
        margin-top: -0.3rem;
        font-weight: 200;
      }
      .office-table-days-closed {
        opacity: 0.7;
        font-weight: 100;
      }
    }
  }
</style>
